export const WORK_DIR_NAME = 'project';
export const WORK_DIR = `/home/${WORK_DIR_NAME}`;
export const MODIFICATIONS_TAG_NAME = 'alpha_file_modifications';
export const USER_PROMPT = 'user_prompt';
export const FIGMA_META_DATA = 'figma_meta_data';
export const API_SPEC_TAG_NAME = 'open_api_spec';
export const API_SPEC_METHOD_NAME = 'open_api_spec_method';
export const PROJECT_RULES_TAG_NAME = 'project_rules';
export const GLOBAL_RULES_TAG_NAME = 'global_rules';
export const SUPABASE_CONTEXT_TAG_NAME = 'supabase_context';
export const SECURITY_ADVISORY_TAG_NAME = 'security_advisory';

export const claude_sonnet_4 = 'claude-sonnet-4-20250514';
export const vertex_claude_sonnet_4 = 'claude-sonnet-4@20250514';
export const vertex_claude_sonnet_4_5 = 'claude-sonnet-4-5@20250929';
export const claude_sonnet_3_7 = 'claude-3-7-sonnet-20250219';
export const claude_sonnet_3_5 = 'claude-3-5-sonnet-20240620';
export const claude_haiku_3_5 = 'claude-3-5-haiku-20241022';

export const gemini_pro = 'gemini-3-pro-preview';
export const gemini_flash = 'gemini-2.5-flash';


export const isDev = process.env.NODE_ENV === 'development';

export const Free_Git_Repo_Size = 25; // 25MB
export const Pro_Git_Repo_Size = 25; // 25MB

export const Free_Git_Repo_Tokens = 100000;
export const Pro_Git_Repo_Tokens = 400000;
export const max_commit_length = 150;

export const Pro_Git_Repo_Limit = 500;
export const Free_Git_Repo_Limit = 100;

export const Pro_Total_Repos_Limit = 500;
export const Free_Total_Repos_Limit = 100;

export const Special_Users = ['shivgun03@gmail.com', 'santosh.ganti@bprhub.com', 'kachmaryk777@gmail.com'];

export const Index_DB_quota = 200; // in MB

// Add constants for OAuthModal
export const THRESHOLD_SIZE = 2; // 2MB
export const MAX_SIZE = 5; // 4MB
export const MAX_DIMENSION = 8000; // 8000px
export const MAX_JSON_TOKENS = 150000; // Maximum length of JSON string (6 lakh characters)
export const TARGET_LONGEST_EDGE = 768;
export const TARGET_MIN_SCALE = 0.25;

export const DUALITE_COMMUNITY_SPREADSHEET_ID = '1J3llbabGrh_W4ncZM4X-GIGKyWQ_1h_25Xp6hJJ-tWQ';

export const FREE_USER_PROMPTS = 20;
export const MAINTENANCE_MODE = false;
